export default __webpack_public_path__ + "static/organiser-4f7e43bf7d42206dab8544595e0c73b8.jpg";